import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import image from 'assets/images/taxonomyApplication.png';
import failedImage from 'assets/images/taxonomyApplicationFailed.png';
import { ApButtonOrange } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 100%;
	height: 100%;
	overflow: auto;
`;

export const ImageContainer = styled.div`
	margin-top: 56px;
	background-image: url(${({ hasFailed }) =>
		hasFailed ? failedImage : image});
	background-repeat: no-repeat;
	background-size: contain;
	min-height: 370px;
	min-width: 370px;
`;

export const TextContainer = styled.div`
	max-width: 550px;
	margin-top: -47px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 24px;
`;

export const Title = styled.div`
	color: ${({ hasFailed }) => (hasFailed ? colors.amber : colors.grey8)};
	margin-bottom: 36px;
	font-weight: 500;
	font-size: 33px;
	line-height: 41px;
	text-align: center;
	letter-spacing: 0.3px;
`;

export const Text = styled.div`
	color: ${colors.grey8};
	font-weight: normal;
	font-size: 13px;
	line-height: 19px;
	text-align: center;
	letter-spacing: 0.3px;
`;

export const Help = styled.div`
	text-align: center;
	color: ${colors.grey5};
`;

export const ProgressBarBackground = styled.div`
	background: ${colors.grey2};
	height: 8px;
	width: 100%;
`;

export const ProgressBarMarker = styled.div`
	background: ${colors.chartBrightTeal};
	transition: width 2s;
	height: 8px;
`;

export const ProgressWrapper = styled.div`
	width: 432px;
	min-width: 432px;
	align-self: center;
	display: flex;
	flex-direction: column;
	padding: 16px 0 32px 0;
`;

export const StyledButton = styled(ApButtonOrange)`
	margin-top: 24px;
`;
